module.exports = __webpack_public_path__ + "tagesrune_600x314.jpg?964b48826fe32efbebb43e2ed7e63e8c";


//////////////////
// WEBPACK FOOTER
// ./lib/assets/tagesrune_600x314.jpg
// module id = 79
// module chunks = 0